import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDps = (props) => /* @__PURE__ */ _jsxs("svg", {
	...props,
	viewBox: "0 0 19 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_1551_15487",
		style: { maskType: "luminance" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 19,
		height: 16,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M19 -3.05176e-05H0V15.2H19V-3.05176e-05Z",
			fill: "white"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_1551_15487)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M14.5475 -3.05176e-05H4.45647C4.3036 -3.05176e-05 4.17969 0.124918 4.17969 0.279049V0.906159C4.17969 1.06029 4.3036 1.18524 4.45647 1.18524H14.5475C14.7004 1.18524 14.8243 1.06029 14.8243 0.906159V0.279049C14.8243 0.124918 14.7004 -3.05176e-05 14.5475 -3.05176e-05Z",
				fill: "#69625D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.34961 0.196136H8.34836C8.29621 0.196136 8.25391 0.238766 8.25391 0.291352V0.893834C8.25391 0.946421 8.29621 0.98905 8.34836 0.98905H9.34961C9.40176 0.98905 9.44406 0.946421 9.44406 0.893834V0.291352C9.44406 0.238766 9.40176 0.196136 9.34961 0.196136Z",
				fill: "#D9D9D9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.55177 0.196136H8.44922V0.98905H8.55177V0.196136Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.25885 0.196136H9.15625V0.98905H9.25885V0.196136Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.78424 0.196136H8.68164V0.98905H8.78424V0.196136Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.01857 0.196136H8.91602V0.98905H9.01857V0.196136Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.25837 0.345428H8.44922V0.553918H9.25837V0.345428Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.64523 0.196136H10.6465C10.6715 0.196136 10.6956 0.206168 10.7133 0.224025C10.731 0.241881 10.7409 0.266099 10.7409 0.291352V0.892196C10.7397 0.917021 10.729 0.94041 10.7111 0.957522C10.6932 0.974634 10.6695 0.984156 10.6449 0.984127H9.64523C9.62018 0.984127 9.59618 0.974095 9.57843 0.956237C9.56073 0.93838 9.55078 0.914163 9.55078 0.888911V0.291352C9.55123 0.266231 9.56128 0.242257 9.57893 0.224491C9.59653 0.206726 9.62033 0.196559 9.64523 0.196136Z",
				fill: "#D9D9D9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.84864 0.196136H9.74609V0.98905H9.84864V0.196136Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.5557 0.196136H10.4531V0.98905H10.5557V0.196136Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.0811 0.196136H9.97852V0.98905H10.0811V0.196136Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.3174 0.196136H10.2148V0.98905H10.3174V0.196136Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.5552 0.345428H9.74609V0.553918H10.5552V0.345428Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.46162 0.196136H5.46129C5.47389 0.196136 5.48639 0.198642 5.49804 0.203509C5.50969 0.208377 5.52029 0.215511 5.52919 0.224505C5.53814 0.233499 5.54519 0.244177 5.55004 0.255928C5.55484 0.267679 5.55734 0.280274 5.55734 0.292993V0.892196C5.55734 0.917884 5.54719 0.942518 5.52919 0.960685C5.51119 0.978846 5.48674 0.98905 5.46129 0.98905H4.46162C4.43657 0.98905 4.41256 0.979018 4.39485 0.961165C4.37714 0.943308 4.36719 0.919091 4.36719 0.893834V0.291352C4.36719 0.266099 4.37714 0.241881 4.39485 0.224025C4.41256 0.206168 4.43657 0.196136 4.46162 0.196136Z",
				fill: "#2B9AFF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.65726 0.196136H4.55469V0.98905H4.65726V0.196136Z",
				fill: "#7DC0FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.36432 0.196136H5.26172V0.98905H5.36432V0.196136Z",
				fill: "#7DC0FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.89359 0.196136H4.79102V0.98905H4.89359V0.196136Z",
				fill: "#7DC0FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.12599 0.196136H5.02344V0.98905H5.12599V0.196136Z",
				fill: "#7DC0FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.36387 0.351624H4.55469V0.56011H5.36387V0.351624Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.75976 0.196136H5.76011C5.70706 0.196136 5.66406 0.239501 5.66406 0.292993V0.892196C5.66406 0.945686 5.70706 0.98905 5.76011 0.98905H6.75976C6.81281 0.98905 6.85581 0.945686 6.85581 0.892196V0.292993C6.85581 0.239501 6.81281 0.196136 6.75976 0.196136Z",
				fill: "#2B9AFF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.95612 0.196136H5.85352V0.98905H5.95612V0.196136Z",
				fill: "#7DC0FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.65954 0.196136H6.55859V0.98905H6.65954V0.196136Z",
				fill: "#7DC0FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.19244 0.196136H6.08984V0.98905H6.19244V0.196136Z",
				fill: "#7DC0FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.42286 0.196136H6.32031V0.98905H6.42286V0.196136Z",
				fill: "#7DC0FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.66272 0.351624H5.85352V0.56011H6.66272V0.351624Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.05539 0.196136H8.05504C8.06764 0.196136 8.08014 0.198642 8.09179 0.203509C8.10344 0.208377 8.11404 0.215511 8.12294 0.224505C8.13189 0.233499 8.13894 0.244177 8.14379 0.255928C8.14859 0.267679 8.15109 0.280274 8.15109 0.292993V0.892196C8.15109 0.917448 8.14114 0.941665 8.12344 0.959523C8.10569 0.97738 8.08169 0.987407 8.05664 0.987407H7.05539C7.03034 0.987407 7.00629 0.97738 6.98859 0.959523C6.97089 0.941665 6.96094 0.917448 6.96094 0.892196V0.291352C6.96094 0.266099 6.97089 0.241881 6.98859 0.224025C7.00629 0.206168 7.03034 0.196136 7.05539 0.196136Z",
				fill: "#2B9AFF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.25489 0.196136H7.15234V0.98905H7.25489V0.196136Z",
				fill: "#7DC0FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.95837 0.196136H7.85742V0.98905H7.95837V0.196136Z",
				fill: "#7DC0FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.48732 0.196136H7.38477V0.98905H7.48732V0.196136Z",
				fill: "#7DC0FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.71974 0.196136H7.61719V0.98905H7.71974V0.196136Z",
				fill: "#7DC0FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.96149 0.351624H7.15234V0.56011H7.96149V0.351624Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9431 0.196136H10.9402C10.888 0.196136 10.8457 0.238766 10.8457 0.291352V0.893834C10.8457 0.946421 10.888 0.98905 10.9402 0.98905H11.9431C11.9952 0.98905 12.0375 0.946421 12.0375 0.893834V0.291352C12.0375 0.238766 11.9952 0.196136 11.9431 0.196136Z",
				fill: "#FF3D3D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.8545 0.196136H11.752V0.98905H11.8545V0.196136Z",
				fill: "#FF9494"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.1455 0.196136H11.043V0.98905H11.1455V0.196136Z",
				fill: "#FF9494"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.6143 0.196136H11.5117V0.98905H11.6143V0.196136Z",
				fill: "#FF9494"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.378 0.196136H11.2754V0.98905H11.378V0.196136Z",
				fill: "#FF9494"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.8538 0.345428H11.043V0.553918H11.8538V0.345428Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.239 0.196136H13.2386C13.2637 0.196136 13.2877 0.206168 13.3054 0.224025C13.3231 0.241881 13.3331 0.266099 13.3331 0.291352V0.892196C13.3331 0.917884 13.3229 0.942518 13.3049 0.960685C13.2869 0.978846 13.2625 0.98905 13.237 0.98905H12.239C12.2139 0.98905 12.1899 0.979018 12.1722 0.961165C12.1545 0.943308 12.1445 0.919091 12.1445 0.893834V0.291352C12.1445 0.266099 12.1545 0.241881 12.1722 0.224025C12.1899 0.206168 12.2139 0.196136 12.239 0.196136Z",
				fill: "#FF3D3D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.1494 0.196136H13.0469V0.98905H13.1494V0.196136Z",
				fill: "#FF9494"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.4365 0.196136H12.334V0.98905H12.4365V0.196136Z",
				fill: "#FF9494"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.9112 0.196136H12.8086V0.98905H12.9112V0.196136Z",
				fill: "#FF9494"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.6748 0.196136H12.5723V0.98905H12.6748V0.196136Z",
				fill: "#FF9494"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.1431 0.345428H12.334V0.553918H13.1431V0.345428Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.5407 0.196136H13.5378C13.4857 0.196136 13.4434 0.238766 13.4434 0.291352V0.893834C13.4434 0.946421 13.4857 0.98905 13.5378 0.98905H14.5407C14.5929 0.98905 14.6352 0.946421 14.6352 0.893834V0.291352C14.6352 0.238766 14.5929 0.196136 14.5407 0.196136Z",
				fill: "#FF3D3D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.4404 0.196136H14.3379V0.98905H14.4404V0.196136Z",
				fill: "#FF9494"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.7354 0.196136H13.6328V0.98905H13.7354V0.196136Z",
				fill: "#FF9494"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.2081 0.196136H14.1055V0.98905H14.2081V0.196136Z",
				fill: "#FF9494"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.9717 0.196136H13.8691V0.98905H13.9717V0.196136Z",
				fill: "#FF9494"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.4436 0.345428H13.6328V0.553918H14.4436V0.345428Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.25132 8.54398H1.07617V15.2008H3.25132V8.54398Z",
				fill: "#111113"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.9193 8.54398H15.7441V15.2008H17.9193V8.54398Z",
				fill: "#111113"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.13539 1.97051L1.07617 8.06921V13.4866H17.9238V8.06921L14.863 1.97051C14.793 1.84756 14.6937 1.74424 14.5739 1.66996C14.4542 1.59569 14.3179 1.55284 14.1776 1.54532H4.82245C4.68183 1.55272 4.54528 1.59551 4.42527 1.66978C4.30526 1.74405 4.2056 1.84743 4.13539 1.97051Z",
				fill: "#242424"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.568 8.89757H3.43042L1.07617 8.06686V13.4827H17.9238V8.06686L15.568 8.89757Z",
				fill: "#171717"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.036 11.6983H4.85513L3.8457 12.9722H15.0471L14.036 11.6983Z",
				fill: "#111113"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.4716 9.88856H6.39226L5.38281 8.61465H13.481L12.4716 9.88856Z",
				fill: "#111113"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.973 10.1971H6.81348C6.73528 10.1971 6.67188 10.2611 6.67188 10.3399V11.2478C6.67188 11.3267 6.73528 11.3906 6.81348 11.3906H11.973C12.0512 11.3906 12.1146 11.3267 12.1146 11.2478V10.3399C12.1146 10.2611 12.0512 10.1971 11.973 10.1971Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.875 5.04292L14.4407 2.18483C14.4103 2.14063 14.3712 2.10325 14.3258 2.075C14.2804 2.04675 14.2297 2.02825 14.1769 2.02066H4.82179C4.76899 2.02825 4.71831 2.04675 4.67293 2.075C4.62755 2.10325 4.58843 2.14063 4.55804 2.18483L3.12368 5.04292C3.09162 5.08606 3.07313 5.13789 3.07061 5.19173C3.06809 5.24557 3.08165 5.29891 3.10953 5.34491C3.13742 5.39085 3.17834 5.42733 3.22702 5.44959C3.27569 5.47185 3.32987 5.47891 3.38255 5.46974H15.6178C15.6701 5.47764 15.7236 5.46979 15.7715 5.44714C15.8194 5.42453 15.8596 5.3881 15.8871 5.34255C15.9145 5.29695 15.928 5.24419 15.9259 5.1909C15.9238 5.1376 15.9061 5.08611 15.875 5.04292Z",
				fill: "#757575"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.3503 6.93194H10.4222C10.3981 6.92895 10.3737 6.93087 10.3504 6.93758C10.327 6.94425 10.3052 6.95558 10.2863 6.97088C10.2673 6.98617 10.2515 7.0051 10.24 7.02662C10.2284 7.0481 10.2212 7.07173 10.2188 7.0961L10.2529 7.7068C10.2621 7.76275 10.2914 7.8133 10.3353 7.84875C10.3792 7.8842 10.4345 7.90205 10.4907 7.89886H11.4871L11.4431 7.5853H10.6128L10.5818 7.20937H11.3959L11.3503 6.93194Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.09744 7.59216L9.11369 6.93057H8.76369L8.71484 7.90573H9.72424L9.71774 7.59216H9.09744Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.51819 7.10138L7.43189 7.71208C7.43049 7.739 7.43494 7.76587 7.44499 7.79082C7.45499 7.81578 7.47034 7.83819 7.48989 7.85653C7.50949 7.87482 7.53279 7.88859 7.55824 7.89683C7.58364 7.90507 7.61054 7.90757 7.63704 7.90419H8.40389C8.46009 7.90772 8.51559 7.89002 8.55959 7.85447C8.60354 7.81897 8.63279 7.76822 8.64159 7.71208L8.67579 7.10138C8.67354 7.07711 8.66654 7.05353 8.65509 7.03205C8.64369 7.01052 8.62809 6.9916 8.60924 6.97625C8.59044 6.96095 8.56874 6.94963 8.54549 6.94291C8.52224 6.93619 8.49789 6.93428 8.47389 6.93722H7.75749C7.70499 6.93276 7.65254 6.94659 7.60894 6.9765C7.56539 7.00641 7.53334 7.05049 7.51819 7.10138ZM8.28014 7.59391H7.81614L7.85844 7.21798H8.31109L8.28014 7.59391Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.1841 7.90573H9.80956L9.78516 6.93057H10.1352L10.1841 7.90573Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.10156 7.90376H6.47441L6.52326 7.66404H7.13376C7.19031 7.66669 7.24601 7.64973 7.29166 7.61599C7.33726 7.58221 7.37006 7.53372 7.38451 7.47856L7.43986 7.10096C7.45291 7.00579 7.36986 6.9368 7.25101 6.9368H6.32301L6.10156 7.90376ZM7.04096 7.36201H6.58511L6.61441 7.21427H7.06701L7.04096 7.36201Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.4316 6.93057L11.5733 7.90573H12.796L12.7276 7.61021H11.8973L11.8843 7.53308H12.7113L12.6495 7.27042H11.8387L11.8273 7.19819H12.6332L12.5729 6.93057H11.4316Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.55004 5.22354H1.77344V5.72588H2.55004V5.22354Z",
				fill: "#242424"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.77463 4.47342H0.473779C0.212118 4.47342 0 4.6873 0 4.95112V5.24825C0 5.51209 0.212118 5.72597 0.473779 5.72597H1.77463C2.03629 5.72597 2.24841 5.51209 2.24841 5.24825V4.95112C2.24841 4.6873 2.03629 4.47342 1.77463 4.47342Z",
				fill: "#363636"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.78017 4.47342H0.477686C0.352032 4.47342 0.231525 4.52375 0.142674 4.61334C0.0538233 4.70293 0.00390625 4.82444 0.00390625 4.95112V5.10052H2.25232V4.95112C2.25232 4.82472 2.20263 4.70346 2.11413 4.61392C2.02563 4.52438 1.90554 4.47385 1.78017 4.47342Z",
				fill: "#757575"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.2239 5.22354H16.4473V5.72588H17.2239V5.22354Z",
				fill: "#242424"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.5227 4.47342H17.2218C16.9602 4.47342 16.748 4.6873 16.748 4.95112V5.24825C16.748 5.51209 16.9602 5.72597 17.2218 5.72597H18.5227C18.7843 5.72597 18.9965 5.51209 18.9965 5.24825V4.95112C18.9965 4.6873 18.7843 4.47342 18.5227 4.47342Z",
				fill: "#363636"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.2274 4.47342H18.5298C18.592 4.47342 18.6535 4.48579 18.7109 4.50982C18.7683 4.53384 18.8204 4.56906 18.8643 4.61344C18.9082 4.65782 18.9429 4.71049 18.9665 4.76845C18.9902 4.8264 19.0022 4.88848 19.002 4.95112V5.10052H16.7617V4.95112C16.7613 4.82572 16.8099 4.70519 16.8971 4.61575C16.9843 4.5263 17.103 4.47515 17.2274 4.47342Z",
				fill: "#757575"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.81874 2.02066C4.76594 2.02825 4.71527 2.04675 4.66988 2.075C4.6245 2.10325 4.58538 2.14063 4.55499 2.18483L3.57812 4.11705H15.4014L14.4245 2.18483C14.3942 2.14063 14.355 2.10325 14.3097 2.075C14.2643 2.04675 14.2136 2.02825 14.1608 2.02066H4.81874Z",
				fill: "#A1A1A1"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.7254 5.04302L13.6261 3.79704C13.6085 3.61712 13.526 3.44998 13.3942 3.32739C13.2624 3.20481 13.0906 3.13533 12.9113 3.13217H12.05C11.8708 3.13533 11.6989 3.20481 11.5671 3.32739C11.4354 3.44998 11.3528 3.61712 11.3353 3.79704L11.2344 5.04302H13.7254Z",
				fill: "#696969"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.9208 5.46999C13.7602 5.2265 13.5423 5.02684 13.2867 4.88874C13.0311 4.75063 12.7455 4.67838 12.4555 4.67838C12.1655 4.67838 11.88 4.75063 11.6243 4.88874C11.3687 5.02684 11.1509 5.2265 10.9902 5.46999H13.9208Z",
				fill: "#242424"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.38255 5.46928H15.6178C15.6704 5.47795 15.7243 5.47065 15.7728 5.44834C15.8212 5.42603 15.862 5.38965 15.8899 5.3439C15.9179 5.29815 15.9317 5.24505 15.9296 5.19136C15.9275 5.13772 15.9097 5.08584 15.8783 5.04245H3.12368C3.09162 5.08555 3.07313 5.13738 3.07061 5.19121C3.06809 5.24505 3.08165 5.2984 3.10953 5.34439C3.13742 5.39033 3.17834 5.42686 3.22702 5.44912C3.27569 5.47138 3.32987 5.4784 3.38255 5.46928Z",
				fill: "#111113"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.65695 2.02066H9.31505V2.64777H8.5254V3.08281C8.5252 3.10795 8.5299 3.13289 8.5393 3.15619C8.5487 3.17948 8.5626 3.20067 8.58015 3.21852C8.5977 3.23638 8.6186 3.25056 8.6416 3.26024C8.66465 3.2699 8.6893 3.27488 8.71425 3.27488H10.2577C10.3082 3.27488 10.3567 3.25465 10.3924 3.21863C10.4281 3.18261 10.4482 3.13375 10.4482 3.08281V2.64777H9.65695V2.02066Z",
				fill: "#696969"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.93631 5.04302L7.83696 3.79704C7.81906 3.61698 7.73621 3.44982 7.60416 3.32726C7.47211 3.20471 7.30006 3.13529 7.12061 3.13217H6.26096C6.08171 3.13533 5.90986 3.20481 5.77806 3.32739C5.64631 3.44998 5.56376 3.61712 5.54626 3.79704L5.44531 5.04302H7.93631Z",
				fill: "#696969"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.29999 8.13309H1.58594V9.18704C1.58594 9.2498 1.59819 9.31192 1.622 9.36988C1.64581 9.42783 1.68071 9.48049 1.7247 9.52482C1.7687 9.56919 1.82092 9.6044 1.87841 9.62838C1.93589 9.6524 1.9975 9.66476 2.05971 9.66476H4.77214V8.61081C4.77235 8.54815 4.7603 8.48607 4.73667 8.42811C4.71304 8.37021 4.67829 8.3175 4.63443 8.27312C4.59056 8.22875 4.53844 8.19354 4.48105 8.16952C4.42366 8.14549 4.36213 8.13309 4.29999 8.13309Z",
				fill: "#C7BCB3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.58594 8.13309V9.18704C1.58594 9.2498 1.59819 9.31192 1.622 9.36988C1.64581 9.42783 1.68071 9.48049 1.7247 9.52482C1.7687 9.56919 1.82092 9.6044 1.87841 9.62838C1.93589 9.6524 1.9975 9.66476 2.05971 9.66476V8.13309H1.58594Z",
				fill: "#F59318"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.02006 9.1315H2.31055V9.34494H4.02006V9.1315Z",
				fill: "#857977"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.02006 8.75778H2.31055V8.97122H4.02006V8.75778Z",
				fill: "#857977"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.02006 8.38492H2.31055V8.59831H4.02006V8.38492Z",
				fill: "#857977"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.6143 8.90022C4.6143 9.01878 4.57941 9.13469 4.51404 9.2333C4.44867 9.33185 4.35576 9.40868 4.24708 9.45394C4.1384 9.49925 4.01883 9.51102 3.90351 9.48777C3.78819 9.46453 3.68231 9.40731 3.59926 9.32332C3.51622 9.23938 3.45975 9.13244 3.437 9.01613C3.41426 8.89978 3.42626 8.77926 3.47149 8.66977C3.51671 8.56033 3.59314 8.46682 3.69108 8.40122C3.78902 8.33556 3.90407 8.3007 4.02167 8.301C4.09964 8.301 4.17683 8.31654 4.24884 8.34665C4.32084 8.3768 4.38625 8.42098 4.4413 8.47663C4.49635 8.53228 4.53997 8.59833 4.56966 8.67104C4.59935 8.74371 4.61452 8.82162 4.6143 8.90022Z",
				fill: "#F0E6DF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.43776 8.89987C4.43776 8.98274 4.41337 9.06369 4.36767 9.13258C4.32198 9.20147 4.25705 9.25511 4.18109 9.28674C4.10513 9.31841 4.02158 9.3266 3.941 9.31032C3.86042 9.29399 3.78644 9.25398 3.72845 9.19529C3.67045 9.13655 3.63104 9.06183 3.6152 8.98048C3.59937 8.89919 3.60783 8.815 3.6395 8.73851C3.67117 8.66207 3.72463 8.59676 3.79312 8.55096C3.86161 8.50516 3.94204 8.48089 4.02422 8.48124C4.07866 8.48124 4.13257 8.49207 4.18285 8.51311C4.23313 8.53419 4.27879 8.56503 4.31721 8.60396C4.35564 8.64285 4.38606 8.68898 4.40675 8.73978C4.42743 8.79053 4.43797 8.84496 4.43776 8.89987Z",
				fill: "#B2A3A0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.6948 8.13309H17.4056V9.18704C17.4056 9.2498 17.3934 9.31192 17.3696 9.36988C17.3458 9.42783 17.3109 9.48049 17.2669 9.52482C17.2229 9.56919 17.1706 9.6044 17.1132 9.62838C17.0557 9.6524 16.9941 9.66476 16.9319 9.66476H14.2227V8.61081C14.2225 8.54815 14.2345 8.48607 14.2582 8.42811C14.2818 8.37021 14.3165 8.3175 14.3604 8.27312C14.4043 8.22875 14.4564 8.19354 14.5138 8.16952C14.5712 8.14549 14.6327 8.13309 14.6948 8.13309Z",
				fill: "#C7BCB3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.4054 8.13309V9.18704C17.4054 9.2498 17.3931 9.31192 17.3693 9.36988C17.3455 9.42783 17.3106 9.48049 17.2666 9.52482C17.2226 9.56919 17.1704 9.6044 17.1129 9.62838C17.0554 9.6524 16.9938 9.66476 16.9316 9.66476V8.13309H17.4054Z",
				fill: "#F59318"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.688 9.1315H14.9785V9.34494H16.688V9.1315Z",
				fill: "#857977"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.688 8.75778H14.9785V8.97122H16.688V8.75778Z",
				fill: "#857977"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.688 8.38492H14.9785V8.59831H16.688V8.38492Z",
				fill: "#857977"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.9771 9.49762C15.3053 9.49762 15.5714 9.22937 15.5714 8.89845C15.5714 8.56753 15.3053 8.29922 14.9771 8.29922C14.6489 8.29922 14.3828 8.56753 14.3828 8.89845C14.3828 9.22937 14.6489 9.49762 14.9771 9.49762Z",
				fill: "#F0E6DF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.5566 8.89982C14.5566 8.98264 14.581 9.06359 14.6266 9.13243C14.6722 9.20127 14.7371 9.25491 14.8129 9.28659C14.8888 9.31826 14.9723 9.32655 15.0528 9.31042C15.1333 9.29429 15.2073 9.25437 15.2654 9.19583C15.3234 9.13728 15.363 9.06271 15.379 8.98151C15.395 8.90031 15.3868 8.81612 15.3554 8.73963C15.3239 8.66314 15.2707 8.59778 15.2025 8.55179C15.1342 8.50575 15.0539 8.48123 14.9718 8.48123C14.8617 8.48123 14.7561 8.52531 14.6782 8.60381C14.6004 8.68236 14.5566 8.78881 14.5566 8.89982Z",
				fill: "#B2A3A0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.0625 12.3855V11.3528C2.0625 11.298 2.08411 11.2454 2.12258 11.2066C2.16105 11.1678 2.21323 11.146 2.26764 11.146H3.59129C3.70526 11.146 3.72642 11.2051 3.6385 11.279L2.22042 12.461C2.13251 12.5382 2.0625 12.5053 2.0625 12.3855Z",
				fill: "#C7BCB3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.86871 11.6136C2.86871 11.6841 2.84799 11.7529 2.80917 11.8115C2.77035 11.8701 2.71517 11.9158 2.65061 11.9427C2.58606 11.9697 2.51502 11.9768 2.44649 11.963C2.37795 11.9492 2.315 11.9153 2.26559 11.8655C2.21618 11.8157 2.18253 11.7522 2.1689 11.6831C2.15527 11.614 2.16227 11.5424 2.18901 11.4773C2.21575 11.4122 2.26103 11.3565 2.31913 11.3174C2.37723 11.2782 2.44554 11.2574 2.51541 11.2574C2.60911 11.2574 2.69898 11.2949 2.76523 11.3617C2.83149 11.4285 2.86871 11.5191 2.86871 11.6136Z",
				fill: "#F0E6DF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.76447 11.6138C2.76447 11.6632 2.74992 11.7115 2.72265 11.7526C2.69539 11.7937 2.65664 11.8257 2.61132 11.8445C2.56601 11.8633 2.51617 11.8682 2.46812 11.8584C2.42007 11.8487 2.37598 11.8248 2.34144 11.7897C2.30689 11.7546 2.28345 11.71 2.27409 11.6615C2.26472 11.613 2.26986 11.5628 2.28884 11.5172C2.30782 11.4716 2.33979 11.4327 2.3807 11.4055C2.42161 11.3783 2.46962 11.364 2.51863 11.3643C2.58398 11.3647 2.64651 11.3912 2.69257 11.4379C2.73862 11.4847 2.76447 11.5479 2.76447 11.6138Z",
				fill: "#B2A3A0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.9412 12.3855V11.3528C16.9412 11.298 16.9195 11.2454 16.881 11.2066C16.8426 11.1678 16.7904 11.146 16.736 11.146H15.414C15.3 11.146 15.2789 11.2051 15.3668 11.279L16.7832 12.461C16.8712 12.5382 16.9412 12.5053 16.9412 12.3855Z",
				fill: "#C7BCB3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.1309 11.6136C16.1309 11.6841 16.1516 11.7529 16.1904 11.8115C16.2292 11.8701 16.2844 11.9158 16.349 11.9427C16.4135 11.9697 16.4845 11.9768 16.5531 11.963C16.6216 11.9492 16.6846 11.9153 16.734 11.8655C16.7834 11.8157 16.817 11.7522 16.8307 11.6831C16.8443 11.614 16.8373 11.5424 16.8106 11.4773C16.7838 11.4122 16.7385 11.3565 16.6804 11.3174C16.6223 11.2782 16.554 11.2574 16.4842 11.2574C16.4378 11.2574 16.3918 11.2666 16.349 11.2845C16.3061 11.3024 16.2671 11.3286 16.2343 11.3617C16.2015 11.3948 16.1755 11.4341 16.1577 11.4773C16.14 11.5205 16.1309 11.5668 16.1309 11.6136Z",
				fill: "#F0E6DF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.2305 11.6138C16.2305 11.6631 16.245 11.7114 16.2722 11.7524C16.2994 11.7935 16.338 11.8254 16.3832 11.8444C16.4285 11.8632 16.4782 11.8682 16.5262 11.8585C16.5742 11.8489 16.6183 11.8251 16.6529 11.7903C16.6875 11.7554 16.7111 11.7109 16.7207 11.6625C16.7302 11.6141 16.7253 11.5639 16.7066 11.5183C16.6878 11.4727 16.6561 11.4338 16.6154 11.4064C16.5747 11.3789 16.5269 11.3643 16.4779 11.3643C16.4123 11.3643 16.3494 11.3906 16.3029 11.4373C16.2565 11.4842 16.2305 11.5476 16.2305 11.6138Z",
				fill: "#B2A3A0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.87418 1.18484H5.23438V1.54272H5.87418V1.18484Z",
				fill: "#111113"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.7685 1.18484H13.127V1.54272H13.7685V1.18484Z",
				fill: "#111113"
			})
		]
	})]
});
export default SvgDps;
